import { api } from '../utils/request'

export const cruiseBooking = async (data) => {
    const resp = await api({
        endpoint: '/cruiseBooking',
        method: 'POST',
        data,
    })
    return resp
}

export const cruiseCity = async () => {
    const resp = await api({
        endpoint: '/cruiseCity',
        method: 'GET',

    })
    return resp
}